import { render, staticRenderFns } from "./ViewItemInfo.vue?vue&type=template&id=8437b176&scoped=true"
import script from "./ViewItemInfo.vue?vue&type=script&lang=js"
export * from "./ViewItemInfo.vue?vue&type=script&lang=js"
import style0 from "./ViewItemInfo.vue?vue&type=style&index=0&id=8437b176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8437b176",
  null
  
)

export default component.exports